import  { useEffect, useState} from "react";
import { ErrorContext } from "../../utils/context/error";
import { getFindUserApi, getUserImport, importUsers } from "../../services/user";
import IconM from "../dashboard/menu/icons/Icon";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";
import FindImportModal from "./findImpmodal";

function UserImport() {
  const [user, setUser] = useState([]);
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);
  const [habilitat, setHabilitat] = useState(true);
  const {setShowToast, setOpciones } = ErrorContext();
  const [selectedRow, setSelectedRow] = useState(null);
  const [showB, setShowB] = useState(false);
  const [importando, setImportando] = useState(false);
  const [consultando, setConsultando] = useState(false);
  const [erroresImportacion, setErroresImportacion] = useState([]);
  const [openErrores, setOpenErrores] = useState(false);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(user, page, 10);  
  
  //--------------------------------------------------------------------------------------------------------------------
  const handlefilas = (Item,index) => 
    {
      setSelectedRow(index);
  
    };
  //--------------------------------------------------------------------------------------------------------------------
  const handleFiltrar = () =>
   {
     setShowB(true);
   }
  
  //-------------------------------------------------------------------------------------------------------------------
  const handleImport = async() =>
   {
     if (usuariosSeleccionados.length === 0) return;
     setShowToast(false);
     setImportando(true);
     const usuarios = usuariosSeleccionados.map((u) => u.UsuarioOrig);
     const response = await importUsers({datas: usuarios});
     if (response) 
        {
          if (response?.status === 200) 
            {
              const importados = response.data.importados ?? [];
              const errores = response.data.errores ?? [];
              
              if (errores.length > 0) {
                setErroresImportacion(errores);
                setOpenErrores(true);
              }

              setUser((prev) =>
                prev.map((item) => {
                   const userImportado = importados.find(
                      (u) => u.UsuarioOrig === item.UsuarioOrig
                    );
                   if (!userImportado) return item;
                   return {
                    ...item,
                    ...userImportado
                    
                   };
                })
             );
            setUsuariosSeleccionados([]);
            setSelectedRow(null);
            setImportando(false);
            
          }
          else 
          {
            setImportando(false);
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
        }  
        else 
          {
            setImportando(false);
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
          
 }
  
  //--------------------------------------------------------------------------------------------------------------------
  const realizarConsulta = async (numeronit, nombreusr) => 
   {
    setShowToast(false);
    setConsultando(true);
    const response = await getFindUserApi(numeronit, nombreusr);
    if (response) 
     {
       if (response.status === 200) 
        {
          setUser(response.data.data ?? []);
          setConsultando(false);
        } 
       else 
        {
          setConsultando(false);
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
      }
    };
  
  //----------------------------------------------------------------------------------------------------------------------
  const fillUserImport = async () => 
      {
        setShowToast(false);
        const response = await getUserImport();
        if (response) 
          {
             if (response.status === 200) 
              {
                setUser(response.data.data ?? []);
                setHabilitat(response.data?.empresa?.[0]?.ApiWlss !== "S");
              } 
             else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
      };
  //--------------------------------------------------------------------------------------------------------------------
  const handleCheckUsuario = (item, checked) => {
    if (checked) 
      setUsuariosSeleccionados((prev) => [...prev, item]);
    else 
      setUsuariosSeleccionados((prev) =>
        prev.filter((u) => u.UsuarioId !== item.UsuarioId)
      );
  };    
  
  //----------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
      fillUserImport();
    }, []);   
  
  //--------------------------------------------------------------------------------------------------------------------
  return (
    <>
     <div className="">
      <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Usuarios/Importar x Api</label>
      </div>
      
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleFiltrar()}  disabled={habilitat}>
              <IconM svg="find" className="iconmenu" title="find" />
              <span>Buscar</span>
            </button>
       
            <button className="btnmenu" onClick={() => handleImport()} disabled={importando || (usuariosSeleccionados.length === 0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Importar</span>
            </button>
       
        </div>
        <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="table-auto min-w-[700px] w-full">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium"></th>
                   <th className="px-2.5 py-2 text-start font-medium">Código Usuario</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre Usuario</th>
                   <th className="px-2.5 py-2 text-start font-medium">Identificación</th>
                   <th className="px-2.5 py-2 text-start font-medium">Correo Electrónico</th>
                   <th className="px-2.5 py-2 text-start font-medium">Teléfono</th>
                   <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                 {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={item.UsuarioId} id={`fila${item.UsuarioId}`} onClick={() => handlefilas(item,index)}>
                         <td className="px-2.5 py-2">
                            {item.Importa === "S" ? (
                              <span className="tagac">I</span>
                            ) : (
                              <input
                                type="checkbox"
                                checked={usuariosSeleccionados.some(
                                  (u) => u.UsuarioOrig === item.UsuarioOrig
                                )}
                                onChange={(e) => handleCheckUsuario(item, e.target.checked)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            )}
                         </td>
                         <td>{item.CodigoUsr}</td>
                         <td>{item.NombreUsr}</td>
                         <td>{item.NumeroNit}</td>
                         <td>{item.Email}</td>
                         <td>{item.Telefono}</td>
                         <td>{item.NombreCar}</td>
                         <td className="center">
                              {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                         </td>          
                       </tr>
                  )})}
               </tbody>
             </table>
             </div>
             <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
       </div>
       {showB && (<FindImportModal showB={showB} handleshow= {setShowB} realizarConsulta={realizarConsulta}></FindImportModal>)}

       {importando && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Importando usuarios...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}

       {consultando && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-blue-600 rounded-full mx-auto mb-4"></div>
              <p className="text-gray-700 font-medium">Consultando usuarios...</p>
              <p className="text-sm text-gray-500">Por favor espere</p>
            </div>
          </div>
       )}

       {openErrores && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-lg shadow-lg w-[700px] max-w-[90vw] p-5">
      <div className="flex justify-between items-center border-b pb-3 mb-4">
        <h2 className="text-lg font-semibold text-gray-700">
          Errores de importación
        </h2>

      </div>

      <div className="mt-2 m-h[400px] rounded-lg border border-stone-200 overflow-x-auto">
         <table className="table-auto">
          <thead className="border-b border-stone-200 text-sm font-medium ">
            <tr>
              <th className="px-2.5 py-2 text-start font-medium">Usuario origen</th>
              <th className="px-2.5 py-2 text-start font-medium">Error</th>
            </tr>
          </thead>

          <tbody>
            {erroresImportacion.map((item, index) => (
              <tr key={index} className="border-b border-stone-200 last:border-0">
                <td className="">{item.UsuarioOrig}</td>
                <td className="">
                  {item.error}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end mt-5">
        <button
          type="button"
          className="btnprimary"
          onClick={() => setOpenErrores(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}
  </>
  );
}
export default UserImport;
